import React, { Component } from 'react';

import './ConditionModal.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classnames from 'classnames';

import Condition from './Condition';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

import ConditionModalInputForm from './ConditionModalInputForm';

class ConditionModal extends Component {

  static defaultProps = {
    toggleConditionModal : () => {
      console.error("toggleConditionModal props not deliveried to ConditionModal");
    },
    handleCreateCondition : () => {
      console.error("handleCreateCondition props not deliveried to ConditionModal");
    }
  }

  state = {
    isCreateCondition : false,
    inputRender : false,
  }

  /**
   * 컨디션 생성 입력 폼 토글
   */
  toggleCreateCondition = () => {
    this.setState({
      isCreateCondition : !this.state.isCreateCondition,
    })
  }

  /**
   * 컨디션 생성 핸들러
   */
  handleCreateCondition = (conditionText) => {
    const { toggleCreateCondition } = this;
    const { handleCreateCondition } = this.props;

    handleCreateCondition(conditionText);

    // // 입력 폼 토글
    // toggleCreateCondition();
  }

  /**
   * white-space 클릭 핸들러
   */
  handleWhiteSpaceClick = (e) => {
    const { isCreateCondition } = this.state;
    const { toggleConditionModal } = this.props;

    this.setState({
      inputRender : false,
    })

    toggleConditionModal();

    if (isCreateCondition) {
      this.toggleCreateCondition();
    }
  }

  /**
   * 컨디션 삭제 핸들러
   */
  handleDeleteCondition = (mapperID) => {
    this.props.handleDeleteCondition(mapperID);
  }

  /**
   * 컨디션 업데이트 핸들러
   */
  handleUpdateCondition = (conditionId, conditionText) => {
    
    

    this.props.handleUpdateCondition(conditionId, conditionText);
  }

  render() {
    const { show } = this.props;
    // const { toggleConditionModal } = this.props;
    const { conditions } = this.props;
    const { handleWhiteSpaceClick } = this;

    const modalClass = classnames({
      'condition-control-modal' : true,
      'show' : show,
      'hide' : !show,
    })
    const whiteSpaceClass = classnames({
      'condition-modal-white-space' : true,
      'show' : show,
      'hide' : !show,
    })

    const conditionsRender = (() => {
      // return conditions.map( condition => (
      //     <Condition key={condition.id} 
      //       conditionText={condition.conditionText} />
      // ));
      
      
      if (conditions) {
        if (conditions.length > 1) {
          // if (itIsExistCondition(conditions)) {
            return conditions.map( (condition, i) => {
              return (
                <Condition key={condition.id}
                  conditionId={condition.id}
                  conditionText={condition.condition}
                  isLast={i === conditions.length-1 ? true : false}
                  deleteCondition={this.handleDeleteCondition}
                  updateCondition={this.handleUpdateCondition}
                />
              );
            });
          // } else {
            
          // }
        } else {
          if (itIsExistCondition(conditions)) {
            return conditions.map( (condition, i) => {
              return (
                <Condition key={condition.id}
                  conditionId={condition.id}
                  conditionText={condition.condition}
                  isLast={i === conditions.length-1 ? true : false}
                  deleteCondition={this.handleDeleteCondition}
                  updateCondition={this.handleUpdateCondition}
                />
              );
            });
          } else {

          }
          return <p className="please-create-condition"> 컨디션이 존재하지 않습니다. </p>
        }
      }
      
    })();
  
    const conditionButtonRender = (() => {
      const { isCreateCondition } = this.state;
      const { toggleCreateCondition } = this;
      const { handleCreateCondition } = this;
      
      if (isCreateCondition) {
        return (
          <div className="condition-create-form">
            <div className="input">
            {
              this.props.show && 
              <ConditionModalInputForm 
                toggleCreateCondition={toggleCreateCondition}
                createCondition={handleCreateCondition} />
            }
            </div>
          </div>
        );
      }
      return (
        <button className='btn btn-secondary create-condition' onClick={toggleCreateCondition}  >
          <FontAwesomeIcon icon={faPlus} className="plus-icon" />  컨디션 생성 
        </button>
      );
    })();

    return (
      <React.Fragment>
        <div class={whiteSpaceClass}
          onClick={handleWhiteSpaceClick}>
        </div>
        <div class={modalClass}>
          {/* <div class="container"> */}
            {/* <div className="row condition-modal-header">
              <span className="header-title"> 컨디션 리스트 </span>
            </div> */}
            <div className="condition-modal-body">
              <div className="conditions-wrapper" >
              {conditionsRender}
              </div>
              <div className="create-condition-wrapper">
                {/* {conditionButtonRender} */}
                {
                  this.props.show &&
                    <ConditionModalInputForm 
                      toggleCreateCondition={this.props.toggleCreateCondition}
                      createCondition={this.handleCreateCondition} />
                }
              </div>
            </div>
          </div>
        {/* </div> */}
      </React.Fragment>
    );
  }
}

const itIsExistCondition = (conditionList) => {
  let flag = false;
  conditionList.some( condition => {
    
    if (condition.condition) {
      flag = true;
    }
  })
  return flag;
}

export default ConditionModal;